export default {
  'photo-ver-title': 'Нұсқаулық бойынша <br/> әрекет етіңіз',
  'photo-ver-text-1': 'Камераны көзіңіз деңгейінде ұстаңыз',
  'photo-ver-text-2': 'Жүзіңізге жарық біркелкі тегіс түсіп тұрғанына көз жеткізіңіз',
  'photo-ver-btn': 'Бастау',
  'photo-ver-header-title': 'Тұлғаңызды растаңыз'
}